<template>
  <div class="foot-container">
    <div style="color: white">
      <span>
        <h1>让世界更安静，让工业更智能!</h1>
        &emsp;&emsp;——————伟思特团队与您共创声学新纪元！<br><br>
      </span>
      <div style="display: flex; flex-direction: row; justify-content: center; align-items: center; margin-top: 20px;">
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: flex-start; margin-right: 20px;">
          <span>
            <el-icon name="phone" style="font-size: 24px; color: white; margin-right: 10px;"></el-icon>
            电话：{{form.phone1}}({{ form.phonePrincipals }}) &emsp; {{form.phone2}}({{ form.phonePrincipals1 }})
          </span>
          <span>
            <el-icon name="message" style="font-size: 24px; color: white; margin-right: 10px;"></el-icon>
            邮箱：{{form.email1}}({{ form.emailPrincipals }}) &emsp; {{form.email2}}({{ form.emailPrincipals1 }})
          </span>
          <span>
            <el-icon name="location" style="font-size: 24px; color: white; margin-right: 10px;"></el-icon>
            地址：{{form.address}}
          </span>
        </div>
      </div>
    </div>
    <hr style="border-color: white; border-style: solid; border-width: 1px 0 0 0; width: 100%; height: 0; margin: 20px 0;">
    <div class="author">
      <span>
        版权所有 © 2025 西安伟思特声学科技有限公司
      </span>&emsp;
      <a href="https://beian.miit.gov.cn/" target="_blank">陕ICP备2025072211号</a>
      &emsp;
      <img src="@/assets/img/head-logo.png" width="16"/>&nbsp;
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=61019002003357" rel="noreferrer" target="_blank">陕公网安备61019002003357号</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Foot",
  data() {
    return {
      form: {
        emailPrincipals: '杨经理',
        emailPrincipals1: '何经理',
        email1: '3319323391@qq.com',
        email2: '',
        phonePrincipals: '杨经理',
        phonePrincipals1: '何经理',
        phone1: '13279501565',
        phone2: '',
        address: '陕西省西安市长安区西沣路与郭杜西街十字西南角熙峰广场601A',
      },
    }
  },
  created() {
    this.getForm();
  },
  methods: {
    getForm() {
      const item = sessionStorage.getItem("appInfo");
      if (item){
        this.form = JSON.parse(item);
        return;
      }
      this.$api.getAppInfo().then(res =>{
        if (res.code !== 200) {
          this.$message.error(res.message);
          return;
        }
        this.form = res.data;
        sessionStorage.setItem("appInfo", JSON.stringify(res.data));
      })
    }
  }
}
</script>

<style scoped>
	.foot-container {
		width: 100%;
    height: 300px;
		display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
		padding-top: 10px;
		padding-bottom: 20px;
		background-color: #000028;
	}

	.author {
		color: #999999;
		font-size: 14px;
    margin: 0 auto;
	}

  .author a {
    color: inherit; /* 继承父元素的文字颜色 */
    text-decoration: none; /* 移除下划线 */
  }

  .author a:hover {
    text-decoration: underline; /* 鼠标悬停时显示下划线 */
  }

</style>